export default __webpack_public_path__ + "static/media/useguide3.e30649de.png";